/* ==========================================================================
   NEU INK B2B PDP — 皮肤层(对话 D)
   --------------------------------------------------------------------------
   ⚠️ 这个文件【只管好看】。它不算价、不改状态、不发任何请求。
      neuink-b2b-pdp.js(算价 / 阶梯 / 加购拆行 / Teeinblue 劫持)
      和 neuink-b2b-preview.js(左栏归属 / 变体广播)一行都没动。
      要是这个文件整个删掉,页面功能照常,只是变丑。

   它补的是 Figma 稿里有、但现有 DOM 里没有的 4 样东西:
     ① 左栏画廊    缩略图 / 左右箭头 / 点击放大
     ② 数量步进器  给原生 number 输入框套 − / + 按钮
     ③ 颜色色块    把 Shopify 原生 swatch 的色值贴到颜色按钮上
     ④ your price  「$45.00 ~~$55.00~~」那一行

   【为什么全用 MutationObserver】
   pdp.js 的 renderColors() / update() 每次交互都会把
   [data-nb=colors]、[data-nb=tier-rows]、[data-nb=sum] 的 innerHTML 整个重写。
   直接改 DOM 会被下一次渲染冲掉,所以一律「观察 → 重新装饰」。

   【和 preview.js 的两条约定,改代码前必读】
   1. preview.js 靠 `.nb-color[aria-pressed=true]` 的 **textContent** 取颜色名。
      所以色块只能加**空的** <i>,绝不能动按钮里的文字节点。
   2. preview.js 换颜色时会改 [data-nb=stage-placeholder] 里那张 <img> 的 src。
      画廊写的是同一张 img —— 两边不抢:缩略图点击时我们写,换颜色时它写,
      它写完我们只负责把对应的缩略图高亮回来(syncActiveThumb)。
   ========================================================================== */
(function () {
  'use strict';

  function readJSON(root, sel) {
    var n = root.querySelector(sel);
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) {
      console.warn('[nb-skin] bad JSON in ' + sel, e);
      return null;
    }
  }

  /* 观察容器的子元素变化,每次变化后重跑 fn。先立即跑一次。 */
  function watch(node, fn) {
    if (!node) return;
    var busy = false;
    var run = function () {
      if (busy) return;          // 防止 fn 自己改 DOM 触发死循环
      busy = true;
      try { fn(); } catch (e) { console.warn('[nb-skin]', e); }
      busy = false;
    };
    run();
    new MutationObserver(run).observe(node, { childList: true, subtree: true });
  }

  /* ========================================================================
     ① 数量步进器
     现有 DOM: <td class="nb-r"><input class="nb-qty" type="number"></td>
     变成:     <td class="nb-r"><div class="nb-stepper">− <input> +</div></td>
     ⚠️ 只是把 input 搬了个位置,pdp.js 早就通过闭包持有它的引用,
        监听器跟着走,不受影响。
     ======================================================================== */
  function decorateSteppers(root) {
    var iconMinus = root.getAttribute('data-nb-icon-minus') || '';
    var iconPlus = root.getAttribute('data-nb-icon-plus') || '';
    var inputs = root.querySelectorAll('.nb-qty');
    Array.prototype.forEach.call(inputs, function (inp) {
      if (inp.parentNode && inp.parentNode.classList.contains('nb-stepper')) return;

      var box = document.createElement('div');
      box.className = 'nb-stepper';

      var mk = function (dir, label, iconUrl) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nb-stepper__b nb-stepper__b--' + dir;
        var icon = document.createElement('img');
        icon.src = iconUrl;
        icon.alt = '';
        icon.width = 10;
        icon.height = 10;
        b.appendChild(icon);
        b.setAttribute('aria-label', label + ' — ' + (inp.getAttribute('aria-label') || 'quantity'));
        b.addEventListener('click', function () {
          var n = parseInt(inp.value || '0', 10);
          if (isNaN(n) || n < 0) n = 0;
          n = (dir === 'up') ? n + 1 : Math.max(0, n - 1);
          inp.value = String(n);
          // pdp.js 监听的是 input 事件 —— 必须派发,否则它不知道数量变了
          inp.dispatchEvent(new Event('input', { bubbles: true }));
          syncStepper(box, inp);
        });
        return b;
      };

      inp.parentNode.insertBefore(box, inp);
      box.appendChild(mk('down', 'Decrease', iconMinus));
      box.appendChild(inp);
      box.appendChild(mk('up', 'Increase', iconPlus));

      inp.addEventListener('input', function () { syncStepper(box, inp); });
      syncStepper(box, inp);
    });
  }

  function syncStepper(box, inp) {
    var n = parseInt(inp.value || '0', 10);
    var down = box.querySelector('.nb-stepper__b--down');
    var up = box.querySelector('.nb-stepper__b--up');
    if (down) down.disabled = inp.disabled || isNaN(n) || n <= 0;
    if (up) up.disabled = inp.disabled;
  }

  /* ========================================================================
     ② 颜色色块
     色值来自 Shopify 原生 swatch(后台 → 商品 → 选项 → 每个颜色值配色)。
     没配的颜色退回文字胶囊,不会变成空白块。
     ======================================================================== */
  function decorateColors(root, swatches) {
    var box = root.querySelector('[data-nb="colors"]');
    if (!box) return;
    Array.prototype.forEach.call(box.querySelectorAll('.nb-color'), function (b) {
      if (b.querySelector('.nb-color__sw') || b.classList.contains('is-text')) return;
      var name = (b.textContent || '').trim();
      var hex = swatches && swatches[name];
      b.title = name;
      b.setAttribute('aria-label', name);
      if (!hex) { b.classList.add('is-text'); return; }
      var sw = document.createElement('i');
      sw.className = 'nb-color__sw';
      sw.style.background = hex;
      // 白/浅色块在白底上看不见,补一道极淡的内描边
      sw.style.boxShadow = 'inset 0 0 0 1px rgba(37,50,75,.12)';
      b.appendChild(sw);   // 只加空元素,textContent 不变 → preview.js 照常工作
    });
  }

  /* ========================================================================
     ③ your price 行
     不重算价格 —— 直接读 pdp.js 已经渲染好的阶梯表:
       第一行 = 挂牌价(25 双档),tr.is-on = 当前套到的档
     ======================================================================== */
  function syncPriceLine(root) {
    var line = root.querySelector('[data-nb-skin="priceline"]');
    /* 弹窗表不突出当前档；详情 Tab 的表由行为层标记 tr.is-on。 */
    var tierRows = root.querySelector('[data-nb="tab-tier-rows"]') ||
      root.querySelector('[data-nb="tier-rows"]');
    if (!line || !tierRows) return;

    var rows = tierRows.querySelectorAll('tr');
    if (!rows.length) return;

    var cell = function (tr) {
      var td = tr.querySelector('td.nb-r');
      return td ? td.textContent.trim() : '';
    };
    var listed = cell(rows[0]);
    var active = tierRows.querySelector('tr.is-on');
    var now = active ? cell(active) : listed;

    var nowEl = line.querySelector('.nb-priceline__now');
    var wasEl = line.querySelector('.nb-priceline__was');
    if (nowEl) nowEl.textContent = now;
    if (wasEl) {
      wasEl.textContent = listed;
      wasEl.hidden = (now === listed);
    }
  }

  /* ========================================================================
     ④ 左栏画廊
     ======================================================================== */
  function initGallery(root) {
    var stage = root.querySelector('[data-nb="stage"]');
    var thumbsBox = root.querySelector('[data-nb-skin="thumbs"]');
    var media = readJSON(root, '[data-nb-media]') || [];

    var mainImg = function () {
      var ph = stage ? stage.querySelector('[data-nb="stage-placeholder"]') : null;
      return ph ? ph.querySelector('img') : null;
    };
    if (!stage || !mainImg() || media.length < 1) {
      var nv = root.querySelectorAll('.nb-gal__nav, .nb-gal__zoom');
      Array.prototype.forEach.call(nv, function (b) { b.hidden = true; });
      return;
    }

    var idx = 0;

    function show(i, writeSrc) {
      if (i < 0) i = media.length - 1;
      if (i >= media.length) i = 0;
      idx = i;
      var img = mainImg();
      if (writeSrc && img && media[i]) {
        img.srcset = '';
        img.src = media[i].src;
        if (media[i].alt) img.alt = media[i].alt;
      }
      if (thumbsBox) {
        Array.prototype.forEach.call(thumbsBox.children, function (t, n) {
          t.classList.toggle('is-on', n === idx);
          t.setAttribute('aria-current', n === idx ? 'true' : 'false');
        });
        var activeThumb = thumbsBox.children[idx];
        if (activeThumb) {
          var left = activeThumb.offsetLeft;
          var right = left + activeThumb.offsetWidth;
          if (left < thumbsBox.scrollLeft) thumbsBox.scrollLeft = left;
          if (right > thumbsBox.scrollLeft + thumbsBox.clientWidth) {
            thumbsBox.scrollLeft = right - thumbsBox.clientWidth;
          }
        }
      }
    }

    /* 缩略图 */
    if (thumbsBox && media.length > 1) {
      media.forEach(function (m, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nb-gal__thumb';
        b.setAttribute('aria-label', 'View image ' + (i + 1));
        var im = document.createElement('img');
        im.src = m.thumb || m.src;
        im.alt = '';
        im.loading = 'lazy';
        b.appendChild(im);
        b.addEventListener('click', function () { show(i, true); });
        thumbsBox.appendChild(b);
      });
    }

    /* 箭头 */
    var prev = root.querySelector('[data-nb-skin="prev"]');
    var next = root.querySelector('[data-nb-skin="next"]');
    if (media.length > 1) {
      if (prev) prev.addEventListener('click', function () { show(idx - 1, true); });
      if (next) next.addEventListener('click', function () { show(idx + 1, true); });
    } else {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    /* 放大灯箱 */
    var zoom = root.querySelector('[data-nb-skin="zoom"]');
    if (zoom) {
      var lb = document.createElement('div');
      lb.className = 'nb-lightbox';
      lb.innerHTML = '<button type="button" class="nb-lightbox__close" aria-label="Close">&times;</button><img alt="">';
      document.body.appendChild(lb);
      var close = function () { lb.classList.remove('is-open'); document.body.style.overflow = ''; };
      zoom.addEventListener('click', function () {
        var img = mainImg();
        lb.querySelector('img').src = (img && img.src) || '';
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        lb.querySelector('.nb-lightbox__close').focus();
      });
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.classList.contains('nb-lightbox__close')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
      });
    }

    /* 换颜色时 preview.js 会自己改主图 —— 我们只把高亮挪过去,不抢着写 src */
    function syncActiveThumb() {
      var img = mainImg();
      if (!img) return;
      var base = (img.currentSrc || img.src || '').split('?')[0];
      for (var i = 0; i < media.length; i++) {
        if (media[i].src.split('?')[0] === base) { show(i, false); return; }
      }
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.nb-color')) {
        window.setTimeout(syncActiveThumb, 60);
        window.setTimeout(syncActiveThumb, 400);
      }
    });

    show(0, false);
  }

  /* ======================================================================== */
  function init(root) {
    if (root.nbSkinDone) return;
    root.nbSkinDone = true;

    var swatches = readJSON(root, '[data-nb-swatches]') || {};

    watch(root.querySelector('[data-nb="size-rows"]'), function () { decorateSteppers(root); });
    watch(root.querySelector('[data-nb="colors"]'),    function () { decorateColors(root, swatches); });
    watch(root.querySelector('[data-nb="tier-rows"]'), function () { syncPriceLine(root); });

    initGallery(root);

    console.log('[nb-skin] ready — 皮肤层已挂上,行为层未被修改');
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.nb-pdp'), init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.nb-pdp'), function (r) {
      r.nbSkinDone = false; init(r);
    });
  });
})();
